
import { defineComponent, PropType } from "vue";
import Button from "../inputs/Button.vue";
import ToggleButton from "../inputs/ToggleButton.vue";
import Slider from "../inputs/Slider.vue";
import Fieldset from "../inputs/Fieldset.vue";
import Checkbox from "../inputs/Checkbox.vue";
import ColorSample from "../global/ColorSample.vue";
import Space from "../global/Space.vue";
import OutlineItemBlock from "./OutlineItemBlock.vue";
import { absColor } from "../../utils/color";

type OutlineOption = { value: string, absColor: string };

export default defineComponent({
  components: {
    ToggleButton, ColorSample, OutlineItemBlock, Fieldset, Button, Space, Slider, Checkbox,
  },
  props: {
    modelValue: { type: Array as PropType<string[]>, required: true },
    thickness: { type: Number, required: true },
    posX: { type: Number, required: true },
    posY: { type: Number, required: true },
    baseColor: { type: String, required: true },
    showDetails: { type: Boolean, required: true },
  },
  emits: [
    "update:modelValue", "update:thickness", "update:posX", "update:posY",
  ],
  computed: {
    options(): OutlineOption[] {
      return [
        { value: "#000000", absColor: "#000000" },
        { value: "darker", absColor: absColor("darker", this.baseColor) },
        { value: "lighterer", absColor: absColor("lighterer", this.baseColor) },
      ];
    },
    absColors(): string[] {
      return this.modelValue.map((color) => absColor(color, this.baseColor));
    },
  },
  methods: {
    update(ix: number, value: string): void {
      this.$emit("update:modelValue", this.modelValue.map((origVal, i) => (
        ix === i ? value : origVal
      )));
    },
    add(): void {
      this.$emit("update:modelValue", [...this.modelValue, "identical"]);
    },
    remove(ix: number): void {
      this.$emit("update:modelValue", this.modelValue.filter((_, i) => i !== ix));
    },
    toggle3D(): void {
      if (this.posX === 0 && this.posY === 0) {
        this.$emit("update:thickness", 4);
        this.$emit("update:posX", -0.9);
        this.$emit("update:posY", -0.9);
      } else {
        this.$emit("update:thickness", 8);
        this.$emit("update:posX", 0);
        this.$emit("update:posY", 0);
      }
    },
  },
});
